<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <h3 class="mt-3">
      {{ $getVisibleNames("mesh.faculty", true, "Facultades") }}
      <AlternativeNameButton
        :table_name="'mesh.faculty'"
        :allows_crud="allows_crud"
      ></AlternativeNameButton>
    </h3>
    <div style="display: flex">
      <div class="col" style="text-align: left">
        <ButtonMedium
          v-can="'mesh.add_faculty'"
          v-if="
            allows_crud &&
            (user.group_names.includes(
              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
            ) ||
              user.is_superuser ||
              $hasObjectPermission('mesh.faculty', 'add'))
          "
          :tooltip_text="
            $t('reusable.common.addTooltip', {
              entity: $getVisibleNames('mesh.faculty', false, 'Facultad'),
            })
          "
          :text_button="$t('reusable.common.add')"
          v-b-modal.new-faculty-modal
          :icon="'plus'"
          :variant="'primary'"
        >
        </ButtonMedium>
      </div>
    </div>
    <GenericBTable
      v-if="facultyList"
      :items="facultyList"
      :filterCustom="filterCustom"
      :pagination="facultyList.length"
      @emitChangeSearchField="changeInputSearch"
      :fields="fields_faculties"
      primary-key="id"
      :filter="input_search"
      :show_pagination="true"
      :search_filter="true"
      :columns_display="true"
      :allows_crud="allows_crud"
      :display_id="display_id"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template v-slot:cell(campus)="row">
        <div class="campus-container">
          <div
            v-for="item in getCampusName(row.item.campuses)"
            :key="item.id"
            class="kl-chip"
          >
            {{ item.name }}
          </div>
        </div>
        <!-- {{ getCampusName(row.item.campuses) }} -->
        <!-- {{row.item.campuses}} -->
      </template>
      <template #cell(color)="row">
        <div
          class="faculty-color"
          :style="{
            'background-color': row.item.color,
            color: row.item.color,
          }"
        ></div>
      </template>
      <template #cell(faculty_area)="row">
        <div class="campus-container">
          <div
            v-for="item in faculty_areas.filter(
              (x) => x.faculty == row.item.id
            )"
            :key="item.id"
            class="kl-chip"
          >
            {{ item.name }}
          </div>
        </div>
      </template>
      <template v-slot:cell(actions)="row">
        <template
          v-if="
            allows_crud &&
            (user.group_names.includes(
              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES'
            ) ||
              user.is_superuser ||
              $hasObjectPermission('mesh.faculty', 'change', row.item.id))
          "
        >
          <b-modal
            :id="`edit-faculty-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames('mesh.faculty', false, 'Facultad'),
              })
            "
            size="lg"
            hide-footer
          >
            <FacultyForm
              :Faculty="row.item"
              @createdArea="slotCreatedArea"
              @updated="slotUpdatedFaculty"
              @updatedArea="slotUpdatedArea"
              @deletedArea="slotDeletedArea"
              :show_title="false"
            ></FacultyForm>
          </b-modal>
          <ButtonSmall
            v-can="'mesh.change_faculty'"
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames('mesh.faculty', false, 'Facultad'),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-faculty-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            v-can="'mesh.delete_faculty'"
            v-if="isValidDelete(row.item.id)"
            :click_button="() => askForDeleteFaculty(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames('mesh.faculty', false, 'Facultad'),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <span
            v-else
            v-b-tooltip.v-secondary.auto.noninteractive="
              $t('organizationalDefinitions.faculty.cannotDelete', {
                faculty: $getVisibleNames('mesh.faculty', false, 'Facultad'),
                programs: $getVisibleNames('mesh.career', true, 'Programas'),
              })
            "
          >
            <ButtonSmall
              :disabled_button="true"
              :tooltip_text="``"
              :icon="'trash'"
            ></ButtonSmall>
          </span>
        </template>
      </template>
    </GenericBTable>
    <div>
      <b-modal
        id="new-faculty-modal"
        :title="
          $t('reusable.common.createModalTitle', {
            entity: $getVisibleNames('mesh.faculty', false, 'Facultad'),
          })
        "
        size="lg"
        hide-footer
      >
        <FacultyForm
          @created="slotCreatedFaculty"
          @createdAreas="slotCreatedAreas"
          :show_title="false"
        ></FacultyForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "FacultyListView",
  components: {
    FacultyForm: () => import("./FacultyForm"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    display_id: {},
  },
  data() {
    return {
      input_search: "",
      sortBy: "",
      sortDesc: false,
      faculty_areas: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      faculties: names.FACULTIES,
      careers: names.CAREERS,
      campuses: names.CAMPUSES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        { text: this.$getVisibleNames("mesh.faculty", true, "Facultades") },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_faculty");
      if (has_permission) return has_permission;
      else return false;
    },
    facultyList() {
      return this.faculties;
    },
    fields_faculties() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames("mesh.faculty", true, "Facultades")
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "color",
          label: this.$t("organizationalDefinitions.faculty.color"),
          sortable: false,
          display_column: true,
        },
        {
          key: "faculty_area",
          label: String(
            this.$getVisibleNames(
              "mesh.facultyarea",
              true,
              "Áreas de las Facultades"
            )
          ),
          display_column: true,
          tdClass: "text-left",
        },
        {
          key: "campus",
          label: String(this.$getVisibleNames("mesh.campus", true, "Sedes")),
          sortable: false,
          display_column: true,
          tdClass: "text-left",
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    filterCustom(row) {
      if (
        this.$filtered(row.name, this.input_search) ||
        this.campuses.filter(
          (x) =>
            this.$filtered(x.name, this.input_search) &&
            row.campuses.includes(x.id)
        ).length > 0 ||
        this.faculty_areas.filter(
          (x) =>
            this.$filtered(x.name, this.input_search) && row.id == x.faculty
        ).length > 0
      ) {
        return true;
      } else return false;
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    getCampusName(campus) {
      let list = [];
      campus.forEach((x) => {
        const instance = this.campuses.find((element) => element.id == x);
        if (instance) list.push(instance);
      });
      return list;
    },
    slotCreatedFaculty() {
      this.$bvModal.hide("new-faculty-modal");
    },
    slotCreatedArea(area) {
      this.faculty_areas.push(area);
    },
    slotCreatedAreas(faculties_areas) {
      faculties_areas.forEach((x) => {
        this.faculty_areas.push(x);
      });
      this.$bvModal.hide("new-faculty-modal");
    },
    slotUpdatedFaculty(faculty) {
      this.$bvModal.hide(`edit-faculty-modal-${faculty.id}`);
    },
    slotUpdatedArea(area) {
      const index = this.faculty_areas.findIndex((x) => x.id == area.id);
      if (index != -1) this.faculty_areas.splice(index, 1, area);
    },
    slotDeletedArea(area_id) {
      const index = this.faculty_areas.findIndex((x) => x.id == area_id);
      if (index != -1) this.faculty_areas.splice(index, 1);
    },
    isValidDelete(faculty_id) {
      const list = this.careers.filter((x) => x.faculty == faculty_id);
      if (list.length > 0) return false;
      else return true;
    },
    askForDeleteFaculty(faculty_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames("mesh.faculty", false, "Facultad"),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(names.DELETE_FACULTY, faculty_id).then(() => {
            toast(
              String(
                this.$getVisibleNames("mesh.faculty", false, "Facultad") +
                  " " +
                  this.$t("reusable.common.deleted")
              )
            );
          });
        }
      });
    },
    fetchFacultiesAreas() {
      this.$restful.GetAll(`/mesh/faculty-area/`).then((response) => {
        this.faculty_areas = response;
      });
    },
  },
  mounted() {},
  created() {
    this.sortBy = "name";
    this.$store.dispatch(names.FETCH_FACULTIES);
    this.$store.dispatch(names.FETCH_CAMPUSES);
    this.$store.dispatch(names.FETCH_CAREERS);
    this.fetchFacultiesAreas();
  },
};
</script>

<style>
.custom-td {
  width: 45% !important;
}
.campus-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  gap: 3px;
}
.custon-tooltip {
  margin-top: 10px;
  z-index: 1;
}
.custon-tooltip::after {
  margin-right: 0.2em;
  transition: 0.2s ease-out;
}
.faculty-color::before {
  min-width: 100px !important;
  height: 20px !important;
  opacity: 1;
  content: " #";
}
</style>